export default __webpack_public_path__ + "static/media/rightArrow.182bd31e.svg";